function toggleNoContentWarning(container, show) {
  const noContent = container.querySelector('.resources-publications-empty');

  if (show) {
    noContent.classList.add('d-block');
  } else {
    noContent.classList.remove('d-block');
  }
}

function showAllResources(container) {
  const resources = [
    ...container.querySelectorAll('.resources-publications-table'),
    ...container.querySelectorAll('.resources-publications-table-row'),
  ];

  resources.forEach((resource) => {
    resource.classList.remove('d-none');
  });
}

function hideResources(resources) {
  resources.forEach((resource) => {
    resource.classList.add('d-none');
  });
}

function filterByFiscalYear(fiscalYear, resourceTable) {
  const resources = Array.from(
    resourceTable.querySelectorAll('.resources-publications-table-row')
  );
  let resourcesToHide = [];

  resources.forEach((resource) => {
    if (
      resource.dataset.fiscalYear !== fiscalYear &&
      resourcesToHide.indexOf(resource) === -1
    ) {
      resourcesToHide.push(resource);
    }
  });

  if (resources.length === resourcesToHide.length) {
    // If all the resources in a table are going to be hidden, hide the table
    resourcesToHide.push(resourceTable);
  }

  return resourcesToHide;
}

function filterResources(filters, container) {
  showAllResources(container);
  toggleNoContentWarning(container, false);

  const resourceTables = Array.from(
    container.querySelectorAll('.resources-publications-table')
  );

  let resourcesToHide = [];
  let tablesToHide = [];

  // Go through each table, if a contentType is present, hide all tables that don't match
  // If there is no contentType, filter by year
  resourceTables.forEach((table) => {
    if (
      filters.contentType !== '' &&
      table.dataset.contentType !== filters.contentType &&
      resourcesToHide.indexOf(table) === -1
    ) {
      resourcesToHide.push(table);
    } else {
      resourcesToHide.push(...filterByFiscalYear(filters.fiscalYear, table));
    }
  });

  // Once we're done compiling our list of resourcesToHide, grab the list of tables
  tablesToHide = resourcesToHide.filter(
    (resource) =>
      resource.classList.contains('resources-publications-table') === true
  );

  // If all tables are going to be hidden, trigger our no-content warning
  if (resourceTables.length === tablesToHide.length) {
    toggleNoContentWarning(container, true);
  }

  // Finally, hide the list of resourcesToHide
  hideResources(resourcesToHide);
}

function getFilterValueInput(filter) {
  const id = filter.querySelector('.dropdown-toggle').id;
  return filter.querySelector(`#${id}-value`);
}

function updateFiscalYearTitle(fiscalYear, container) {
  const fiscalYearTitle = container.querySelector(
    '.resources-publications-fiscal-year'
  );

  fiscalYearTitle.textContent = fiscalYear;
}

function initializeFilters(container) {
  // Filter Dropdowns
  let fiscalYearFilter = container.querySelector(
    '[data-filter][data-filter-type="fiscalYear"]'
  );
  let contentTypeFilter = container.querySelector(
    '[data-filter][data-filter-type="contentType"]'
  );

  // Filter Hidden Inputs which Hold Custom Dropdown Values
  const fiscalYearValueInput = getFilterValueInput(fiscalYearFilter);
  const contentTypeValueInput = getFilterValueInput(contentTypeFilter);

  // Initialize Page Load Filters
  let filters = {
    fiscalYear: fiscalYearValueInput.value,
    contentType: contentTypeValueInput.value,
  };
  filterResources(filters, container);

  // Listen for Filter Updates
  fiscalYearValueInput.addEventListener('change', (e) => {
    filters.fiscalYear = e.target.value;
    updateFiscalYearTitle(e.target.value, container);
    filterResources(filters, container);
  });
  contentTypeValueInput.addEventListener('change', (e) => {
    filters.contentType = e.target.value;
    filterResources(filters, container);
  });
}

export function initializeResourcesPublicationsFilters() {
  const containers = Array.from(
    document.querySelectorAll('.resources-publications')
  );
  containers.forEach(initializeFilters);
}
